<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">

        <form class="mt-4 xs:w-4/6 sm:w-5/6 lg:w-4/6 mx-auto leading-tight sm:leading-normal"
        @submit.prevent="handleSubmit(onSubmit)" >
            <div class="flex flex-col space-y-2">
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="firstName"
                        rules="required"
                        v-slot="{errors}"
                    >
                        <input-form
                            :type="'text'"
                            :name="'firstName'"
                            v-model="formInputs.firstName"
                        >
                            NOMBRE*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="secondName"
                        rules="required"
                        v-slot="{errors}"
                    >
                        <input-form
                            :type="'text'"
                            :name="'secondName'"
                            v-model="formInputs.secondName"
                        >
                            SEGUNDO NOMBRE
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="fatherLastName"
                        rules="required"
                        v-slot="{errors}"
                    >
                        <input-form
                            :type="'text'"
                            :name="'fatherLastName'"
                            v-model="formInputs.fatherLastName"
                        >
                            PRIMER APELLIDO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="motherLastName"
                        rules="required"
                        v-slot="{errors}"
                        >
                        <input-form
                            :type="'text'"
                            :name="'motherLastName'"
                            v-model="formInputs.motherLastName"
                        >
                            SEGUNDO APELLIDO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="fechaNacimiento"
                        rules="required"
                        v-slot="{errors}"

                    >   
                        <input-form
                            :type="'date'"
                            :name="'fechaNacimiento'"
                            v-model="formInputs.birthdayDate"
                        >
                            FECHA DE NACIMIENTO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="rfc"
                        rules="required"
                        v-slot="{errors}"

                    >
                        <input-form
                            :type="'text'"
                            :name="'rfc'"
                            v-model="formInputs.rfc"
                        >
                            RFC*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    
                </div>
                
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="cellphone"
                        rules="required"
                        v-slot="{errors}"
                        >
                        <input-form
                            :type="'text'"
                            :name="'cellphone'"
                            v-model="formInputs.cellphone"
                        >
                            TELEFONO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="email"
                        rules="required"
                        v-slot="{errors}"
                    >
                        <input-form
                            :type="'text'"
                            :name="'email'"
                            v-model="formInputs.email"
                        >
                            CORREO ELECTRONICO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="postal_code"
                        rules="required"
                        v-slot="{errors}"
                    >

                        <input-form
                            :type="'text'"
                            :name="'postal_code'"
                            v-model="formInputs.postalCode"
                        >
                            CÓDIGO POSTAL*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="colonia"
                        rules="required"
                        v-slot="{errors}"
                    >   
                        <v-select-form
                            :name="'colonia'"
                            :options="suburbs"
                            v-model="formInputs.suburb"
                            @input="onSuburbChange"
                        >
                            COLONIA*
                        </v-select-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="state_name"
                        rules="required"
                        v-slot="{errors}"
                    >
                        <input-form
                            :type="'text'"
                            :name="'state_name'"
                            v-model="formInputs.stateName"
                            disabled
                        >
                            ESTADO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="municipality"
                        rules="required"
                        v-slot="{errors}"
                    >
                        <input-form
                            :type="'text'"
                            :name="'municipality'"
                            v-model="formInputs.municipality"
                            disabled
                        >
                            MUNICIPIO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>    
                <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                    <ValidationProvider
                        class="sm:w-1/2"
                        name="street_name"
                        rules="required"
                        v-slot="{errors}"
                    >   
                        <input-form
                            :type="'text'"
                            :name="'street_name'"
                            v-model="formInputs.streetName"
                        >
                            CALLE*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                        class="sm:w-1/2"
                        name="street_number"
                        rules="required"
                        v-slot="{errors}"
                    >   
                        <input-form
                            :type="'text'"
                            :name="'street_number'"
                            v-model="formInputs.streetNumber"
                        >
                            NÚMERO DOMICILIO*
                        </input-form>
                        <span class="text-sm text-red">{{ errors[0] }}</span>
                    </ValidationProvider>
                        
                </div>
            </div>
            <div class="mt-6 flex flex-col space-y-2 items-center justify-end sm:flex-row sm:space-y-0 sm:space-x-2">     
                <button
                    type="submit"
                    class="hyundai-button w-40 py-0 h-8"
                >Guardar</button>
            </div>
        </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate";

import "../../components/f2/helpers/form_validations";


export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: ["activities"],

    
    data() {
        return {
            url: $(".url").text(),
            formComplete: false, // Variable para validar que el formulario esté completo
            // Campos del formulario
            formInputs: {
                firstName:"",
                secondName: "",
                motherLastName:"",
                fatherLastName:"",
                rfc:"",
                cellphone:"",
                postalCode:"",
                email:"",
                stateName:"",
                municipality:"",
                suburb:"",
                streetName:"",
                streetNumber:"",
                'aval': true, 
            },
            suburbs: []

        }
    },

    methods:{
        onSuburbChange(value){
            this.formInputs.suburb = value
            his.formInputs.stateName = value.estado
            this.formInputs.municipality = value.municipio
        },
        onSubmit(){
            const formData = {
                    type: 1,
                    data: { ...this.formInputs },
                };
                formData.data.suburb = this.formInputs.suburb.description
            this.$emit("add-person", formData);
        },
        getRfc(){
            this.formInputs.rfc = this.formInputs.fatherLastName !== undefined ? this.formInputs.fatherLastName.substring(0, 2).toUpperCase() : ''
            this.formInputs.rfc += this.formInputs.motherLastName !== undefined ? this.formInputs.motherLastName.substring(0, 1).toUpperCase() : ''
            this.formInputs.rfc += this.formInputs.firstName !== undefined ? this.formInputs.firstName.substring(0, 1).toUpperCase() : ''
            if(this.formInputs.birthdayDate != ''){
                const birthdayDate = this.formInputs.birthdayDate.split('-')
                this.formInputs.rfc += birthdayDate[0].substring(2) + birthdayDate[1] + birthdayDate[2]
            }
        }
    },
    watch: {
        'formInputs.firstName'(){
            this.getRfc()
        },
        'formInputs.motherLastName'(){
            this.getRfc()
        },
        'formInputs.fatherLastName'(){
            this.getRfc()
        },
        'formInputs.birthdayDate'(){
            this.getRfc()
        },
        'formInputs.postalCode'(value){
            axios.get(`${this.url}/abc/getSuburb/${value}`)
            .then((res)=>{
                this.suburbs = res.data.data.map(e => new Object({
                    id: e.id, 
                    description: e.asentamiento,
                    estado: e.estado,
                    municipio: e.municipio
                }))
                this.formInputs.stateName = this.suburbs[0].estado
                this.formInputs.municipality = this.suburbs[0].municipio
            })
        }
        
    }
}
</script>

<style>

</style>